import { useEtsyCircuitBreakerStore } from '@/helpers/etsy-circuit-breaker';
export default {
  path: '/compare-listings',
  name: 'compare-listings',
  meta: {
    title: 'eRank — Compare Listings',
    noScroll: true,
    requiresAuth: true,
    metaTags: [
      {
        name: 'description',
        content: 'Compare Etsy listings in one table with eRank. Use daily views, sales estimates, prices, categories, and tags to uncover opportunities and improve your shop.',
      },
      {
        page_slug: 'compare-listings',
      },
    ],
  },
  component: () => import('@/modules/compare-listings/pages/Entry.vue'),
  beforeEnter: async () => {
    const etsyCircuitBreakerStore = useEtsyCircuitBreakerStore();
    const response = await etsyCircuitBreakerStore.requestStatus();
    etsyCircuitBreakerStore.setActions(response.data);
    return true;
  },
};
